import {
  FilterMode,
  WorkerEvent_OrderBy,
  WorkerEvent,
  SortOrder,
  WorkerEvent_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const workerEventService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.workerEventOne({ id });
    return result.workerEventOne as WorkerEvent;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: WorkerEvent_OrderBy[] | null = null,
    filter: WorkerEvent_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: WorkerEvent_Filter | undefined;
    if (searchValue !== "") {
      where = {
        OR: [
          {
            queueName: { contains: searchValue, mode: FilterMode.Insensitive },
          },
          { jobType: { contains: searchValue, mode: FilterMode.Insensitive } },
        ],
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.workerEventListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ queueName: SortOrder.Asc }, { jobType: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.workerEventListWithOffset
    ) as WorkerEvent[];
    return { list, orderBy };
  },
};
